
import { CreateDataItem, CreateModelData, DatasetCleanupType } from "../Models/Models";
import { DatasetReport } from "../Models/DatasetReport";
import RespondClient from "../Models/RespondClient";
import { getApiHost } from "../util";
import { getInstance } from "./InstanceProvider";

export default class DataProvider {
    public dataProvider: DataProvider | undefined;

    public init() {
        if (!this.dataProvider) {
            this.dataProvider = new DataProvider();
        }
    }

    public create(data: CreateModelData): Promise<RespondClient<unknown>> {
        return getInstance().post(`${getApiHost()}/api/data`, data);
    }

    public createItem(data: CreateDataItem): Promise<RespondClient<unknown>> {
        return getInstance().post(`${getApiHost()}/api/data/item`, data);
    }

    public remove(data: string): Promise<RespondClient<unknown>> {
        return getInstance().delete(`${getApiHost()}/api/data/${data}`);
    }

    public clean(data: string, cleanType: DatasetCleanupType): Promise<RespondClient<unknown>> {
        return getInstance().delete(`${getApiHost()}/api/data/schema/${data}?type=${cleanType}`);
    }

    public getReport(schemaId: string): Promise<RespondClient<DatasetReport>> {
        return getInstance().get(`${getApiHost()}/api/data/${schemaId}/report`);
    }
}

export const DataProviderInstance = new DataProvider();
